export default __webpack_public_path__ + "static/media/linkedin-logo..cf78b0a2.png";